<template>
    <div>
        <div>
            <h3 class="form-heading">{{ trans('Billing') }}</h3>
            <div v-if="model.parent_id === 0 && model.frequency_id !== 1" class="form-group">
                <label class="control-label">Auto Billing</label>
                <input id="switch" type="checkbox" name="white_label" v-model="model.autobill" checked="checked" class="toggle-switch toggle-switch-light">
                <label for="switch" class="toggle-switch-btn"></label>
            </div>
            <div class="form-group">
                <label class="control-label">5% off is: ${{ (model.amount - (model.amount/100*5)).toFixed(2) }}</label>
                <!-- <input id="switchquickapay" type="checkbox" name="white_label_quickapay" v-model="model.quickapay" checked="checked" class="toggle-switch toggle-switch-light">
                <label for="switchquickapay" class="toggle-switch-btn"></label> -->
            </div>
        </div>

    <div v-if="model.payments.length">
        <h3 class="form-heading">{{ trans('Invoice Payments') }}</h3>
        <!-- Invoice Buttons -->
        <ul class="list-group">
            <li v-for="payment in model.payments" class="list-group-item">
                <span class="badge" v-html="payment.amount"></span>
                <a :href="'/api/payment/' + payment.public_id" class="loadPanel" onclick="loadPanel(event)">
                    <h4 class="list-group-item-heading"><strong>#{{ payment.public_id }}</strong> - {{ payment.date }}</h4>
                </a>
                <p class="list-group-item-text">
                    <span v-if="payment.transaction_reference">Ref: {{ payment.transaction_reference }}</span>
                </p>
            </li>
        </ul>
    </div>

    <!-- Heading -->
    <h3 class="form-heading">{{ trans('invoice_tools') }}</h3>
    <!-- Invoice Buttons -->
    <div class="row invoice-buttons">
        <div class="col-lg-12">
            <a class="btn btn-primary" :href="model.getPDF" target="_blank">
                <i class="icon icon-download"></i> {{ trans("download_pdf") }}</a>
            <div id="primaryActions" style="text-align:left" class="btn-group dropdown">
                <button class="btn btn-primary drop loadPanel" type="button" @click.prevent="$root.createDialog('payment', { invoice: {id: model.public_id, name: model.name }, company: {id: model.company_id, name:model.company_name} } )">
                    <i class="icon icon-dollar"></i> {{ trans("pay_invoice") }}</button>
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                    <span class="caret"></span></button>
                <ul class="dropdown-menu">
                    <li><a @click.prevent="$root.createDialog('payment', { invoice: {id: model.public_id, name: model.name }, company: {id: model.company_id, name:model.company_name} } )">{{ trans("enter_payment") }}</a></li>
                    <li><a :href="model.getPaymentUrl" target="_blank">{{ trans("pay_cc") }}</a></li>
                    <li><a @click="copyLink()" target="_blank">Copy link</a></li>
                    <li v-if="ifInternal">
                        <a @click="tokenPayment('stripe')">Stripe: Pay With Default Token</a>
                    </li>
                    <li v-if="ifInternal">
                        <a @click="tokenPayment('eway')">eWay: Pay With Default Token</a>
                    </li>
                </ul>
            </div>

            <div id="primaryActions3" style="text-align:left" class="btn-group dropdown" v-if="ifInternal && model.hasProposals">
                <button class="btn btn-primary drop" type="button" :href="'/invoice/' + model.public_id + '/proposal'" @click="button($event)">Edit Proposal</button>
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                    <span class="caret"></span></button>
                <ul class="dropdown-menu">
                    <li><a :href="'/invoice/' + model.public_id + '/proposal/generate'" target="_blank">{{ trans("View PDF") }}</a></li>
                  <li><a :href="'/invoice/' + model.public_id + '/proposal/download'" target="_blank">{{ trans("Download PDF") }}</a></li>
                  <li><a @click="areYouSure('/invoice/' + model.public_id + '/proposal/deleteAll')">{{ trans("Delete PDF") }}</a></li>
                  <li><a :href="model.getPublicProposal" target="_blank">{{ trans("Public Proposal Link") }}</a></li>
                </ul>
            </div>

            <button v-if="ifInternal && !model.hasProposals" class="btn btn-primary" type="button" :href="'/invoice/' + model.public_id + '/proposal'" @click="button($event)">Create Proposal</button>

            <div id="primaryActions2" style="text-align:left" class="btn-group dropdown">
                <button class="btn btn-default drop" :href="model.getLink" type="button" @click="button($event)">
                    <i class="icon icon-edit"></i> {{ trans("edit_invoice") }}</button>

                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown">
                    <span class="caret"></span></button>
                <ul class="dropdown-menu">
                    <li><a :href="'/invoice/' + model.public_id + '/clone'">{{ trans("clone_invoice") }}</a></li>
                    <li v-if="model.parent_id === 0"><a @click.prevent="createRenewal()">{{ trans("create_renewal") }}</a></li>
                    <li><a @click.prevent="mark(2)">{{ trans("mark_sent") }}</a></li>
                    <li><a @click.prevent="mark(1)">Mark Draft</a></li>
                    <!-- <li><a @click.prevent="mark(4)">Mark Partial Payment</a></li> -->
                    <li><a @click.prevent="mark(5)">Mark Paid</a></li>
                    <!--  <li><a @click.prevent="mark(6)">Mark Refunded</a></li>
                    <li><a @click.prevent="mark(7)">Mark Credit</a></li> -->
                </ul>
            </div>

        </div>
    </div>
    <!-- Email Invoice Form -->
    <mailer :invoice_id="model.public_id"></mailer>
    </div>
</template>
<script>
    export default {
        components: {
            'mailer': require('../mail/mailer.vue').default,
        },
        data() {
            return {
                completedRender: false,
                model: {
                    hasProposals: false,
                    balance: 0,
                    frequency_id: 0,
                    parent_id: 0,
                    autobill: false,
                    quickapay: false,
                    payments: [],
                    name: '',
                    getPDF : '',
                    getPaymentUrl : '',
                    getPublicProposal: '',
                    getLink : '',
                    public_id: '',
                    company_id : '',
                    company_name : 'Fix company name setting (todo)',
                    amount: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('setInvoice', this.setInvoice);
            this.$nextTick(function () {
            });
        },
        watch: {
            'model.autobill': function (value) {
                if (this.completedRender) {
                    this.enableAutobill();
                }
            },
            'model.quickapay': function (value) {
                if (this.completedRender) {
                    this.toggleQuickapay();
                }
            }
        },
        methods: {
            copyLink()
            {
                navigator.clipboard.writeText(this.model.getPaymentUrl);
            },
            button(event) {
                let el = $(event.target);
                window.location = el.attr('href');
            },
            tokenPayment(type) {
                let callback = () => {
                    this.$root.toggleLoader(true);
                    this.axios.post('/api/token-pay', {
                        id: this.model.public_id,
                        type: type,
                        balance: this.model.balance
                    }).then((response) => {
                        this.$root.toggleLoader(false);
                        myAlert(response.data);
                    }).catch(e => {
                        console.log(e);
                        myAlert('There was an error. Please refresh.')
                        this.$root.toggleLoader(false);
                    })
                };
                myAlert({
                    heading: 'Are you sure?',
                    type: 'warning',
                    message: 'This will charge the clients card for ' + this.model.balance,
                    callback: callback
                });
            },
            areYouSure(url) {
              myAlert({
                heading: 'Are you sure?',
                type: 'warning',
                message: 'This cannot be undone ',
                callback: () => {
                  window.location = url;
                }
              });
            },
            enableAutobill() {
                this.axios.post('/api/invoice/autobill', {
                    id: this.model.public_id
                }).then((response) => {
                    console.log(response.data.success);
                }).catch(e => {
                    console.log(e);
                    myAlert('There was an error. Please refresh.')
                })
            },
            toggleQuickapay(){
                this.axios.post('/api/invoice/quickapay', {
                    id: this.model.public_id
                }).then((response) => {
                    console.log(response.data.success);
                }).catch(e => {
                    console.log(e);
                    myAlert('There was an error. Please refresh.')
                })
            },
            createRenewal() {
                this.axios.get('/api/invoice/' + this.model.public_id + '/createRenewal').then((response) => {
                    if (typeof response.data !== 'undefined' && typeof response.data['url'] !== 'undefined') {
                        window.location = response.data['url'];
                        return;
                    }
                    myAlert('Sorry, there was an error creating that renewal');
                })
            },
            mark(status_id) {
                this.$store('/api/invoice/mark', {
                    id: this.model.public_id,
                    status_id: status_id
                });
            },
            setInvoice(data) {
                this.completedRender = false;
                this.model = this.$setData(data, this.model);
                this.$nextTick(function () {
                    // Code that will run only after the
                    // entire view has been re-rendered
                    this.completedRender = true;
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setInvoice', this.setInvoice);
        }
    }
</script>